import * as helper from "./../../../Assets/Js/helper";
import * as Events from "./Events";

export default class SignupHandler {
	constructor(pfm, ab3, pt) {
		this.started = false;
		this.ab3 = ab3;
		this.pt = parseInt(pt, 10);
		this.paytourInitObject = {
			targetUrl: "",
			pfm: pfm,
			host: 0,
			hideClose: false,
			minAmount: 2500, // cents
			disableJump: true,
			option: "2XITGA",
			texts: {
				BonusTextCustom: "& erhalte 100% Bonus geschenkt",
				BonusTextCustomSecondary: "Erhalte 100% Bonus geschenkt!",
				TicketHeadline: "Sooo Geil!",
			},
		};

		if (ab3 === 1) {
			this.paytourInitObject = {
				targetUrl: "",
				pfm: pfm,
				host: 0,
				minAmount: 2500, // cents
				hideClose: false,
				disableJump: true,
				option: "",
				lpId: "ConversionChatGeneric",
				login: 0,
				successUrl: "https://www.visit-x.net/?jump=freechat",
				hideSignupConfirmation: true,
				texts: {
					BonusTextCustom: " ",
				},
				conversion: {
					signup: {
						headerClassMobile: "conversion-chat",
						headerHeadlineMobile: "GRATIS WEBCAM", // hier den neuen Text,
						headerSubheadlineMobile: "echte Amateure & bekannte Erotikstars",
						background:
							"https://www.visit-x.net/assets/img/teaser/conversion-chat/vxpay-conversion-chat-signup-lexyroxx.jpg", // hier das Bild ersetzen
						backgroundMobile:
							"https://www.visit-x.net/assets/img/teaser/conversion-chat/vxpay-conversion-chat-signup-mobile-lexyroxx.png", // hier das Bild ersetzen
					},
				},
			};
		}

		if (this.pt === 0) {
			this.paytourInitObject.hideSignupConfirmation = true;
		}

		helper.addEventListener(window, Events.START_ACTION, () => {
			this.started = true;
		});

		helper.addEventListener(window, Events.VIDEO_LIMIT_REACHED, () => {
			this.paytourInitObject.hideClose = true;
		});

		helper.addEventListener(window, Events.CREATE_SIGNUP, () => {
			this._handleSignup();
		});

		helper.addEventListener(window, Events.VIDEO_CHANGED, (evt) => {
			if (this.ab3 !== 1) {
				this.paytourInitObject.host = evt.detail.uid;
			}
		});
	}

	_handleSignup() {
		if (this.pt === 0 || this.ab3 === 1 || this.ab3 === 2) {
			window.paytourHelper.openSignup(this.paytourInitObject);
		} else {
			window.paytourHelper.openPaytour(this.paytourInitObject);
		}
	}
}
